import { Card, Row, Col, Tag } from "antd";
import classes from "./operational.module.scss";
import { Typography } from "antd";
const { Title, Text } = Typography;

const MarketTrends = () => {
  // Dummy Market Trends
  const marketTrends = [
    { title: "AI Adoption Surge", type: "Opportunity", tagColor: "green" },
    { title: "New Global Data Privacy Laws", type: "Risk", tagColor: "red" },
    { title: "Increased Cloud Costs", type: "Risk", tagColor: "orange" },
    {
      title: "Growing Demand for Cybersecurity",
      type: "Opportunity",
      tagColor: "green",
    },
    { title: "Regulatory Pressure on Fintech", type: "Risk", tagColor: "red" },
    {
      title: "Sustainable Tech Investments Rising",
      type: "Opportunity",
      tagColor: "green",
    },
  ];

  return (
    <>
      {" "}
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Market Trends System
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Detailed external environment scanner.
        </Text>
      </div>
      <div style={{ padding: "40px 20px" }}>
        <Row gutter={[16, 16]}>
          {marketTrends.map((trend, index) => (
            <Col span={6}>
              <Card key={index} hoverable>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  <Tag color={trend.tagColor} style={{ width: "min-content" }}>
                    {trend.type}
                  </Tag>
                  <span
                    style={{ fontSize: "16px", fontWeight: 500, marginLeft: 8 }}
                  >
                    {trend.title}
                  </span>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};
export default MarketTrends;
